"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Input/Input.module.css"));
var CheckBox = (function (_super) {
    __extends(CheckBox, _super);
    function CheckBox(props) {
        var _this = _super.call(this, props) || this;
        _this.changeFocus = _this.changeFocus.bind(_this);
        return _this;
    }
    CheckBox.prototype.changeFocus = function (nextInputId) {
        setTimeout(function () {
            var nextInputRef = document.getElementById(nextInputId);
            nextInputRef.focus();
        });
    };
    CheckBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, onChange = _a.onChange, json_data = _a.json_data, className = _a.className, _b = _a.errors, errors = _b === void 0 ? {} : _b, classNameWrap = _a.classNameWrap, disabled = _a.disabled;
        var checked = json_data[id] === "yes";
        var error = errors[id];
        var css = "base-checkbox " + className;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", { className: classNameWrap || "" },
            error && React.createElement("p", { className: styles.error },
                error,
                " "),
            React.createElement("input", { className: css, type: "checkbox", id: id, checked: checked, onChange: function (event) {
                    var value = "no";
                    if (event.target.checked) {
                        if (_this.props.nextInputId) {
                            _this.changeFocus(_this.props.nextInputId);
                        }
                        value = "yes";
                    }
                    onChange(id, value);
                }, disabled: disabled })));
    };
    return CheckBox;
}(react_1.Component));
exports.CheckBox = CheckBox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tCb3guanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0NoZWNrQm94LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQiwrREFBa0Q7QUFhbEQ7SUFBOEIsNEJBQW9CO0lBQzlDLGtCQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FFZjtRQURHLEtBQUksQ0FBQyxXQUFXLEdBQUcsS0FBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsS0FBSSxDQUFDLENBQUE7O0lBQ2xELENBQUM7SUFFRCw4QkFBVyxHQUFYLFVBQVksV0FBVztRQUNuQixVQUFVLENBQUM7WUFDUCxJQUFNLFlBQVksR0FBRyxRQUFRLENBQUMsY0FBYyxDQUFDLFdBQVcsQ0FBQyxDQUFBO1lBQ3pELFlBQVksQ0FBQyxLQUFLLEVBQUUsQ0FBQTtRQUN4QixDQUFDLENBQUMsQ0FBQTtJQUNOLENBQUM7SUFFTSx5QkFBTSxHQUFiO1FBQUEsaUJBd0NDO1FBdkNTLElBQUEsZUFRUSxFQVBWLFVBQUUsRUFDRixzQkFBUSxFQUNSLHdCQUFTLEVBQ1Qsd0JBQVMsRUFDVCxjQUFXLEVBQVgsZ0NBQVcsRUFDWCxnQ0FBYSxFQUNiLHNCQUNVLENBQUE7UUFDZCxJQUFJLE9BQU8sR0FBWSxTQUFTLENBQUMsRUFBRSxDQUFDLEtBQUssS0FBSyxDQUFBO1FBQzlDLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUV4QixJQUFJLEdBQUcsR0FBRyxtQkFBaUIsU0FBVyxDQUFBO1FBQ3RDLElBQUksS0FBSyxFQUFFO1lBQ1AsR0FBRyxHQUFNLEdBQUcsU0FBSSxNQUFNLENBQUMsU0FBVyxDQUFBO1NBQ3JDO1FBRUQsT0FBTyxDQUNILDZCQUFLLFNBQVMsRUFBRSxhQUFhLElBQUksRUFBRTtZQUM5QixLQUFLLElBQUksMkJBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxLQUFLO2dCQUFHLEtBQUs7b0JBQU07WUFDbEQsK0JBQ0ksU0FBUyxFQUFFLEdBQUcsRUFDZCxJQUFJLEVBQUMsVUFBVSxFQUNmLEVBQUUsRUFBRSxFQUFFLEVBQ04sT0FBTyxFQUFFLE9BQU8sRUFDaEIsUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixJQUFJLEtBQUssR0FBaUIsSUFBSSxDQUFBO29CQUM5QixJQUFJLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFO3dCQUN0QixJQUFJLEtBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxFQUFFOzRCQUN4QixLQUFJLENBQUMsV0FBVyxDQUFDLEtBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLENBQUE7eUJBQzNDO3dCQUNELEtBQUssR0FBRyxLQUFLLENBQUE7cUJBQ2hCO29CQUNELFFBQVEsQ0FBQyxFQUFFLEVBQUUsS0FBSyxDQUFDLENBQUE7Z0JBQ3ZCLENBQUMsRUFDRCxRQUFRLEVBQUUsUUFBUSxHQUNwQixDQUNBLENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFDTCxlQUFDO0FBQUQsQ0FBQyxBQXRERCxDQUE4QixpQkFBUyxHQXNEdEM7QUF0RFksNEJBQVEifQ==